import { render, staticRenderFns } from "./InventoryModal.vue?vue&type=template&id=36176fe3&"
import script from "./InventoryModal.vue?vue&type=script&lang=js&"
export * from "./InventoryModal.vue?vue&type=script&lang=js&"
import style0 from "./InventoryModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports